import React from 'react';
import AccountContainer from '../components/account.container';

const AccountPage: React.FC = () => {
  return <AccountContainer />;
};

export default AccountPage;
